export default __webpack_public_path__ + "images/0x539bde0d7dbd336b79148aa742883198bbf60342.png";